import { stringEnum } from 'common/utils/objects';

export const CookieNoticeOptions = stringEnum(['SHOW_NOTICE', 'DISABLE', 'ENABLE']);
